export const EnvConfig = {
  isProduction: false,
  ServerUrl: '',
  risksdkPublicKey: 'pk_sbox_yfe32nwrkd6hze3jgxn7a36idyw',
  risksdkURL: 'https://risk.sandbox.checkout.com/cdn/risk/2.3/risk.js',
  risksdkIntegrity: 'sha384-ZGdiIppkJzwran7Bjk0sUZy5z1mZGpR/MJx7LC0xCTyFE2sBpPFeLu4r15yGVei6',
  GA_TRACK_ID: 'G-4TL6EN84C0',
  GA_TRACK_DEBUG_MODE: 'false',
};
